import {ListContract} from './list-contract';

export default ListContract;
